<script>
  import {parseNumber, calcPercent} from "../../Common/tools";
  import {onMount} from "svelte";
  import {External, M} from "../../external";
  import {getAutomationSalesTotals, getEmailAndMessageSteps, getStepSalesUTM} from "../static";
  import {EMPTY_SALES_TOTALS, getSalesCountLabel} from "../../Store/static";

  export let data;
  export let setGoal;
  export let hasSentItems;

  let isEmailsInFlow = false, isMessagesInFlow = false;
  let flowHeading;
  let automationSalesTotals;

  onMount(async function () {
    const steps = getEmailAndMessageSteps(data.flow.steps);

    let stepUtms;

    for (const step of steps) {
      if (step.type === "SEND_EMAIL") {
        isEmailsInFlow = true;
      } else {
        isMessagesInFlow = true;
      }

      let stepUtm = getStepSalesUTM(step);

      if (stepUtm) {
        if (!stepUtms) {
          stepUtms = [];
          automationSalesTotals = EMPTY_SALES_TOTALS; //renders more smoothly if we init to 0 before awaiting on getAutomationSalesTotals below
        }

        if (!stepUtms.includes(stepUtm)) {   //some steps may have identical UTM params, so dont count them twice
          stepUtms[stepUtms.length] = stepUtm;
        }
      }
    }

    if (stepUtms) {
      automationSalesTotals = await getAutomationSalesTotals(data, ...stepUtms);
    }

    flowHeading = isEmailsInFlow && isMessagesInFlow ? M.AUTOMATION_FLOW : (isMessagesInFlow ? M.MESSAGE_FLOW : (isEmailsInFlow ? M.EMAIL_FLOW : M.AUTOMATION_FLOW));
  });

</script>


<div class="flex col20 f-left store-section-analytics-warapper three-columns flex-col-mobile mt-15" style="background: rgb(245, 246, 250);">
  <div class="analytics-box">
    <h3>{M.TOTAL_USERS_ENTERED}</h3>
    <h2 class="col20 f-left f-28 gray-text"><b>{data.completed + data.waiting}</b></h2>
  </div>
  <div class="analytics-box">
    <h3>{M.COMPLETED_THE_FLOW}</h3>
    <h2 class="col20 f-left f-28 gray-text"><b>{data.completed} <span class="increase">({calcPercent(data.completed, data.completed + data.waiting)})</span></b></h2>
  </div>
  <div class="analytics-box">
    <h3>{M.STILL_IN_THE_FLOW}</h3>
    <h2 class="col20 f-left f-28 gray-text"><b>{data.waiting} <span class="increase">({calcPercent(data.waiting, data.completed + data.waiting)})</span></b></h2>
  </div>
  {#if automationSalesTotals}
    <div class="analytics-box">
      <h3>{M.PURCHASED}</h3>
      <h2 class="col20 f-left f-28 gray-text"><b>{External.Tools.currencyToStrWithSymbol(automationSalesTotals.sales)} <span class="increase">({automationSalesTotals.orders})</span></b></h2>
    </div>
  {/if}
</div>
<div class="flex f-left col20 mt-25">
  <div class="analytics-box-half" style="padding-right: 0;">
    <h2 class="col20 f-left f-28 gray-text">{flowHeading}</h2>
    <div class="chart-wrapper col20 f-left mt-35">
      <div class="horizontal-chart-wrapper flex align-center">
        <h4>{M.SENT}</h4>
        <div class="horizontal-chart-progress">
          <div class="horizontal-chart-progress-inner" style="width:{hasSentItems ? 100 : 0}%;">
            <span class="chart-label">{parseNumber(data.sent)} - {hasSentItems ? 100 : 0}%</span>
          </div>
        </div>
      </div>

      {#if isEmailsInFlow}
        <div class="horizontal-chart-wrapper flex align-center">
          <h4>{M.OPENED}</h4>
          <div class="horizontal-chart-progress">
            <div class="horizontal-chart-progress-inner" style="width:{calcPercent(data.opened, data.sent)}; background-color: #cac736">
              <span class="chart-label">{calcPercent(data.opened, data.sent)}</span>
            </div>
          </div>
        </div>
        <div class="horizontal-chart-wrapper flex align-center">
          <h4>{M.CLICKED}</h4>
          <div class="horizontal-chart-progress">
            <div class="horizontal-chart-progress-inner" style="width:{calcPercent(data.clicked, data.sent)}; background-color: #cac736">
              <span class="chart-label">{calcPercent(data.clicked, data.sent)}</span>
            </div>
          </div>
        </div>
      {/if}

      <div class="horizontal-chart-wrapper flex align-center">
        <h4>{M.GOAL_REACHED}</h4>
        <div class="horizontal-chart-progress">
          <div class="horizontal-chart-progress-inner" style="width:{calcPercent(data.goalReached, data.completed + data.waiting)}; background-color: #76bd65">
            <span class="chart-label">{data.goalReached} - {calcPercent(data.goalReached, data.completed + data.waiting)}</span>
          </div>
        </div>
      </div>

      {#if automationSalesTotals}
        <div class="horizontal-chart-wrapper flex align-center">
          <h4>{M.PURCHASED}</h4>
          <div class="horizontal-chart-progress">
            <div class="horizontal-chart-progress-inner" style={"width:" + calcPercent(automationSalesTotals.orders, data.sent) + "; background-color: #76bd65"}>
              <span class="chart-label">{calcPercent(automationSalesTotals.orders, data.sent)} - {External.Tools.currencyToStrWithSymbol(automationSalesTotals.sales)} ({getSalesCountLabel(automationSalesTotals.orders)})</span>
            </div>
          </div>
        </div>
      {/if}
    </div>
  </div>
  <div class="analytics-box-half automation-goal-wrapper mb-35">
    <h2 class="col20 f-left f-21 gray-text mb-25">{M.AUTOMATION_GOAL}</h2>
    <div class="col20 f-left flex align-center goal-box-wrapper" style="padding: 20px; box-sizing: border-box; background: #fff;">
      <span class="material-icons-outlined circle-automation-icon"> emoji_events </span>
      <div class="flex-1">
        <h3>{M.COMPLETED_THE_GOAL}</h3>
        <h2 class="col20 f-left f-28 gray-text">
          <b>{data.goalReached} <span class="increase">({calcPercent(data.goalReached, data.completed + data.waiting)})</span></b>
        </h2>
      </div>
      {#if setGoal}
        <a on:click={setGoal} class="middle-button blue">{M.EDIT_GOAL}</a>
      {/if}
    </div>
  </div>
</div>
